import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import {
  LayoutColumn,
  LayoutRow,
  MarginTopHeaderHeight,
} from './DashboardLayout.styled';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { AppMode } from 'store/Common/reducers/common';
import { useIsHeaderSubHeaderExpanded } from '../Header/hooks';

export function DashboardLayout() {
  const appMode: AppMode = useSelector(
    (state: IRootReducerState) => state.commonInfo.appMode
  );
  const isHeaderExpanded = useIsHeaderSubHeaderExpanded();

  return (
    <LayoutRow>
      <LayoutColumn
        isHeaderExpanded={isHeaderExpanded}
        isExternal={appMode === AppMode.EXTERNAL}
      >
        <Header />
        <MarginTopHeaderHeight />
        <Outlet />
      </LayoutColumn>
    </LayoutRow>
  );
}

export default DashboardLayout;
